
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M9.51798 22C9.02805 20.4022 8.28891 19.211 7.30054 18.4265C5.81799 17.2498 3.46242 17.9811 2.59229 16.7674C1.72217 15.5536 3.20191 13.3215 3.72117 12.0044C4.24043 10.6874 1.73089 10.2217 2.02388 9.84783C2.21921 9.59856 3.48736 8.87928 5.82833 7.68998C6.4935 3.89666 8.95041 2 13.1991 2C19.5721 2 22 7.40297 22 10.8394C22 14.2759 19.0601 17.9781 14.872 18.7763C14.4976 19.3217 15.0377 20.3963 16.4924 22"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.74986 7.24991C9.42319 8.51705 9.52038 9.40681 10.0414 9.91919C10.5625 10.4316 11.4505 10.7666 12.7056 10.9244C12.4209 12.5587 12.768 13.3255 13.7471 13.2246C14.7262 13.1237 15.3145 12.7169 15.512 12.0041C17.0421 12.4341 17.8714 12.0742 17.9999 10.9244C18.1926 9.19956 17.2625 7.82368 16.8812 7.82368C16.4999 7.82368 15.512 7.77728 15.512 7.24991C15.512 6.72255 14.358 6.42459 13.3165 6.42459C12.275 6.42459 12.9018 5.72255 11.4716 5.99991C10.5182 6.18482 9.94424 6.60149 9.74986 7.24991Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiAi",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
